module.exports = __webpack_public_path__ + "img/cpu (2).390a2bef.svg";